<template>
	<div class="container page">
		<van-nav-bar :title="this.vod_name" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="right">
			<van-pull-refresh border="false" class="list-wrapper" v-model="isLoading" @refresh="onRefresh"
				:pulling-text="$t('refresh.pulling')" :loosing-text="$t('refresh.loosing')"
				:loading-text="$t('refresh.loading')">
				<van-grid :column-num="2" :gutter="10">
					<van-grid-item @click="profile(v.id)" v-for="(v, k) in datalist" :key="k">
						<van-image class="game_item_img"  :src="v.img_url">
							<template v-slot:loading>
								<van-loading type="circular" />
							</template>
						</van-image>
						<div class="choose_list_c">

							<div class="flex-box-x" style="width: 100%;margin-bottom: 4px;">

								<span class="rig-name" style="margin-top: 0;">{{ $t('xuanfeilist.name') }}：{{
									v.xuanfei_name
									}}</span>
							</div>

							
							<div style="width: 100%;margin-bottom: 4px;">

								<span class="rig-name">{{ $t('xuanfeilist.age') }}：{{ v.birthday }}</span>
</div>
							<div style="width: 100%;margin-bottom: 4px;">

								<span class="rig-name">{{ $t('xuanfeilist.city') }}: {{ v.address }}</span>
							</div>
							<div style="width: 100%;margin-bottom: 4px;">

								<span class="rig-name">{{ $t('xuanfeilist.job') }}：{{ v.service }}</span>
							</div>
							<span class="rig-name">
								<!-- {{ $t('xuanfeilist.introduce') }}： -->
								{{ v.content }}</span>
						</div>
					</van-grid-item>
				</van-grid>
			</van-pull-refresh>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			vod_name: '北京',
			isLoading: false,
			datalist: [
				// {
				// 	xuanfei_name: '北京 健身达人',
				// 	img_url: 'https://kk.betman2.co/storage/41/62fe1bd26d01c_image_2022-08-18_190032731.png'
				// },
				// {
				// 	xuanfei_name: '北京 学生妹',
				// 	img_url: 'https://kk.betman2.co/storage/344/630869b4bd2d6_1.jpg'
				// }
			]
		};
	},
	methods: {
		back() {
			this.$router.push({ path: 'Choose' });
		},
		onRefresh() {
			setTimeout(() => {
				this.$toast(this.$t("reservation.refresh"));
				this.isLoading = false;
			}, 500);
		},
		profile(id) {

			if (!localStorage.getItem('token')) {
				this.$router.push({ path: '/Login' });
			} else {
				this.$router.push({ path: '/profile?id=' + id + '&name=' + this.vod_name + '&adsid=' + this.$route.query.id });
			}
		},
		getxuanfeilist() {
			this.$http({
				method: 'get',
				url: 'xuanfeilist',
				data: { id: this.$route.query.id }
			}).then(res => {
				console.log(res.data)
				this.datalist = res.data;
			});
		}
	},
	created() {
		this.vod_name = this.$route.query.name;
		this.getxuanfeilist();
	}
};
</script>

<style scoped>
.right {
	margin-top: 10px;
}

::v-deep .van-grid-item__content--center {
	border-radius: 15px;
	padding: 0;
	/* height: auto; */
}

::v-deep .van-image__img {
	border-radius: 10px;
	padding: 15px;
}

.rig-name {
	/* height: 60px;
	line-height: 60px; */
	/* margin:10px 0; */
	/* text-align: center; */
	/* background-color: #f7f7f7; */
	border-radius: 0 0 15px 15px;
	font-size: 15px;
	font-size: 18px;
}

.choose_list_c {
	width: 100%;
	padding: 10px;
	padding-top: 0;
}
.game_item_img{
	height: 360px;
}
</style>
